export const enumKeyByValue = <T extends Record<string, string>>(
  enumeration: T,
  enumValue: (typeof enumeration)[keyof typeof enumeration]
): keyof T => {
  return Object.keys(enumeration).filter((e) => enumeration[e] === enumValue)[0];
};
